<template>
  <div class="flex justify-between items-center mb-2">
    <div>
      <span class="text-xl font-bold">Total:</span>
      <span class="font-light"> ({{ TotalItems }} items)</span>
    </div>
    <h2 class="text-xl md:text-2xl font-bold">{{Currency}}{{ formattedTotalCost }}</h2>
  </div>
  <button
    @click="proceed"
    class="text-secondary-600 bg-primary-600 w-full hover:bg-primary-500 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none disabled:bg-disabled-300 disabled:shadow-none disabled:ring-0 disabled:cursor-not-allowed disabled:bg-primary-500"
    type="button"
  >
    Proceed
  </button>
</template>

<script setup>
import { computed } from 'vue';

import { useBasketStore } from '@/stores/basket';
import { useAccountStore } from '@/stores/account';
import { useRouter } from 'vue-router';

const router = useRouter();

const TotalItems = computed(() => useBasketStore().TotalItems);
const TotalCost = computed(() => useBasketStore().TotalCost);
const formattedTotalCost = computed(() => new Intl.NumberFormat().format(TotalCost.value));
const Currency = computed(() => useAccountStore().Currency);
const Jwt = computed(() => useAccountStore().Jwt);

const proceed = () => {
  router.replace({
    name: 'PlaceOrder',
    query: {
      token: Jwt.value,
    },
  });
};
</script>
